export const ROUTES = {
  BASE: '/',
  LOGIN: 'login',
  LOGIN_CALLBACK: 'login/callback',
  ROSTERS: 'rosters',
  AUTHORIZATIONS: 'authorizations',
  PAYER_CONFIG: 'payer-configuration',
  ENCOUNTERS: 'encounters',
  FAXES: 'faxes',
  NOT_FOUND: '404',
};
